<template>

	<div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
		<div>
			<!-- <h4 class="main-title mb-0" v-if="status">
                <router-link to="/muddemal" type="button"><i class="ri-arrow-left-line menu_icon text-dark fs-18 lh-1 me-2"></i></router-link>Create Muddemal
            </h4> -->
			<h4 class="main-title mb-0">
				<router-link to="/muddemal" type="button"><i
						class="ri-arrow-left-line menu_icon text-dark fs-18 lh-1 me-2"></i></router-link> Update
				Muddemal
			</h4>
		</div>
		<div class="d-flex gap-2 mt-3 mt-md-0">
			<router-link to="/muddemal" type="button" class="btn btn-primary"><i
					class="ri-menu-line fs-18 lh-1 me-1"></i>Muddemals</router-link>
		</div>
	</div>
	<div class="row g-3">
		<div class="col-md-12">
			<div class="card mb-4">
				<div class="card-body">
					<div class="mb-2">
						<h5 class="mb-0">Muddemal Input Details</h5>
						<div class="row">
							<div class="col-12">
								<div class="col-12 d-flex flex-row-reverse">
									<div class="d-flex align-items-center">
										<label class="form-check me-3">
											<input type="radio" class="form-check-input" value="CRIME_NO"
												v-model="form.number_type">
											Crime No.
										</label>

										<label class="form-check me-3">
											<input type="radio" class="form-check-input" value="UDR_NO"
												v-model="form.number_type">
											UDR No.
										</label>

										<label class="form-check me-3">
											<input type="radio" class="form-check-input" value="NCR_NO"
												v-model="form.number_type">
											NCR No.
										</label>
										<label class="form-check">
											<input type="radio" class="form-check-input" value="C_MISC"
												v-model="form.number_type">
											C Misc.
										</label>
									</div>
								</div>
								<div class="row my-2 g-3">
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">PF Number
												<span class="text-danger"> * </span>
											</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('pf_number')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="PF Number"
											:class="{ 'is-invalid': errors.pf_number }" v-model="form.pf_number"
											ref="pf_number" />
										<span v-if="errors.pf_number" class="invalid-feedback">{{ errors.pf_number[0]
											}}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">PF Date<span class="text-danger"> *</span></label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('pf_date')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="date" class="form-control"
											:class="{ 'is-invalid': errors.pf_date }" v-model="form.pf_date"
											@change="getYearFromDate(form.pf_date)" max="9999-12-31" />
										<span v-if="errors.pf_date" class="invalid-feedback">{{ errors.pf_date[0]
											}}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">PF Year<span class="text-danger"> *</span></label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('year')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input readonly type="text" class="form-control" placeholder="PF Year"
											:class="{ 'is-invalid': errors.year }" v-model="form.year" />
										<span v-if="errors.year" class="invalid-feedback">{{ errors.year[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">{{ number_type_label }}<span class="text-danger">
													*</span></label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('crime_no_sec')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" :placeholder="number_type_label"
											:class="{ 'is-invalid': errors.crime_no_sec }"
											v-model="form.crime_no_sec" />
										<span v-if="errors.crime_no_sec" class="invalid-feedback">{{
											errors.crime_no_sec[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<label class="form-label">Section of Law (IPC/BNS)</label>
										<input type="text" class="form-control" placeholder="Section of Law"
											:class="{ 'is-invalid': errors.section_of_law }"
											v-model="form.section_of_law" />
										<span v-if="errors.section_of_law" class="invalid-feedback">{{
											errors.section_of_law[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Investigation Officer [Seized Officer]</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('investigation_officer')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="Investigation Officer"
											:class="{ 'is-invalid': errors.investigation_officer }"
											v-model="form.investigation_officer" />
										<span v-if="errors.investigation_officer" class="invalid-feedback">{{
											errors.investigation_officer[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<label class="form-label">Seizing Officer</label>
										<input type="text" class="form-control" placeholder="Enter seizing officer name"
											v-model="form.seizing_officer" />
									</div>
									<div class="col-3 mb-3">
										<label class="form-label">Crime Year</label>
										<input type="text" class="form-control" placeholder="Enter year (e.g., 2024)"
											v-model="form.crime_year" maxlength="10" />
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Seized From Whom</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('siezed_from_whom')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="Seized From Whom"
											:class="{ 'is-invalid': errors.siezed_from_whom }"
											v-model="form.siezed_from_whom" />
										<span v-if="errors.siezed_from_whom" class="invalid-feedback">{{
											errors.siezed_from_whom[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Seized From Place</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('siezed_from_place')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="Seized From Place"
											:class="{ 'is-invalid': errors.siezed_from_place }"
											v-model="form.siezed_from_place" />
										<span v-if="errors.siezed_from_place" class="invalid-feedback">{{
											errors.siezed_from_place[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">CC No/ SC No</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('cc_sc_no')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="CC No/ SC No"
											:class="{ 'is-invalid': errors.cc_sc_no }" v-model="form.cc_sc_no" />
										<span v-if="errors.cc_sc_no" class="invalid-feedback">{{ errors.cc_sc_no[0]
											}}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Present Stage of the Case <span class="text-danger">*</span></label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('case_stage_id')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<search :class="{ 'is-invalid': errors.case_stage_id }"
											:customClass="{ 'is-invalid': errors.case_stage_id }"
											:initialize="form.case_stage_id" id="case_stage_id" label="case_stage"
											placeholder="Select Case Stage" :data="case_stages"
											@input="case_stage => form.case_stage_id = case_stage">
										</search>
										<span v-if="errors.case_stage_id" class="invalid-feedback">{{
											errors.case_stage_id[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">PR No.</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('pr_no')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="PR No."
											:class="{ 'is-invalid': errors.pr_no }" v-model="form.pr_no" />
										<span v-if="errors.pr_no" class="invalid-feedback">{{ errors.pr_no[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">PR Date</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('pr_date')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="date" class="form-control" placeholder="PR Date"
											:class="{ 'is-invalid': errors.pr_date }" v-model="form.pr_date"
											max="9999-12-31" />
										<span v-if="errors.pr_date" class="invalid-feedback">{{ errors.pr_date[0]
											}}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Holding Officer [Current]</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('holding_officer')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<input type="text" class="form-control" placeholder="Holding Officer"
											:class="{ 'is-invalid': errors.holding_officer }"
											v-model="form.holding_officer" />
										<span v-if="errors.holding_officer" class="invalid-feedback">{{
											errors.holding_officer[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Police Station</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('police_station_id')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<search :class="{ 'is-invalid': errors.police_station_id }"
											:customClass="{ 'is-invalid': errors.police_station_id }"
											:initialize="form.police_station_id" id="police_station_id"
											label="police_station" placeholder="Select Police Station"
											:data="police_stations"
											@input="police_station => { form.police_station_id = police_station; getSubDivisionAndCircle(police_station); }"
											@selectsearch="getSubDivisionAndCircle(form.police_station_id)">
										</search>
										<span v-if="errors.police_station_id" class="invalid-feedback">{{
											errors.police_station_id[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Circle</label>
										</div>
										<search :class="{ 'is-invalid': errors.circle_id }"
											:customClass="{ 'is-invalid': errors.circle_id }"
											:initialize="form.circle_id" id="circle_id" label="circle"
											placeholder="Select Circle" :data="circles"
											:disabled="true">
										</search>
										<span v-if="errors.circle_id" class="invalid-feedback">{{
											errors.circle_id[0] }}</span>
									</div>
									<div class="col-3 mb-3">
										<div class="d-flex justify-content-between">
											<label class="form-label">Sub Division</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('sub_division_id')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<search :class="{ 'is-invalid': errors.sub_division_id }"
											:customClass="{ 'is-invalid': errors.sub_division_id }"
											:initialize="form.sub_division_id" id="sub_division_id" label="sub_division"
											placeholder="Select Sub Division" :data="sub_divisions"
											:disabled="true">
										</search>
										<span v-if="errors.sub_division_id" class="invalid-feedback">{{
											errors.sub_division_id[0] }}</span>
									</div>
									<div class="col-3 mb-3" v-if="selected_division == 'CCB'">
										<div class="d-flex justify-content-between">
											<label class="form-label">PF Transferred PS</label>
											<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
												@click="getMuddemalFieldHistory('transferred_ps_id')"
												class="ri-history-line fs-18  text-primary"></i>
										</div>
										<search :class="{ 'is-invalid': errors.transferred_ps_id }"
											:customClass="{ 'is-invalid': errors.transferred_ps_id }"
											:initialize="form.transferred_ps_id" id="police_station_id"
											label="police_station" placeholder="Select Police Station"
											:data="all_police_stations"
											@input="police_station => form.transferred_ps_id = police_station">
										</search>
										<span v-if="errors.transferred_ps_id" class="invalid-feedback">{{
											errors.transferred_ps_id[0] }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mb-2">
						<div class="d-flex justify-content-between">
							<div class="d-flex">
								<h5 class="mb-0">Seized Property Details</h5>
								<span class="text-danger">*</span>
								<i class="ri-error-warning-line text-danger mx-1" v-if="errors.properties"></i>
							</div>
							<button v-if="formStatus" class="btn btn-sm btn-success" type="button"
								@click.prevent="addProperty()"><i class="ri-add-line fs-18 lh-1"></i> Add</button>
						</div>

						<div class="row">
							<div class="col-md-12">
								<div class="table-responsive mt-2" style="overflow-y: scroll;">
									<table class="table text-nowrap table-bottom-border mb-4">
										<thead>
											<tr style="background-color: #f5f5f5;">
												<th>Property Type</th>
												<th>Property Description</th>
												<th>Quantity / Weight</th>
												<th>Seized Property Available</th>
												<th>Remarks If Property Not Available</th>
												<th>Valuable / Non Valuable</th>
												<th>Property Value</th>
												<th>Property Disposed</th>
												<th>Property Disposed Reason</th>
												<th>Disposed Date</th>
												<th>Incharge Officer</th>
												<th>If Any Remarks By Incharge Officer</th>
												<th>Auction Value</th>
												<th>Auction Date</th>
												<th>Property Photo</th>
												<th class="text-center col-fsl-actions">FSL</th>
												<th class="text-center col-court-actions">Court</th>
												<th class="text-center col-current-location">Current Location</th>
												<th class="text-center col-shelf">Shelf</th>
												<th class="text-center col-destroyed-actions">Destroyed</th>
												<th class="text-center">Delete</th>
											</tr>
										</thead>
										<tbody>
											<!-- try -->
											<tr v-for="property, key in form.properties" :key="key">
												<td>
													<div class="input-group">
														<select class="form-control" style="width: 120px; flex:none;"
															:class="{ 'is-invalid': property.errors.property_type_id }"
															v-model="property.property_type_id"
															@change="checkPropertyType(property)">
															<option value="">Select Property Type</option>
															<option v-for="property_type, key in property_types"
																:key="key" :value="property_type.property_type_id"> {{
																	property_type.property_type }}</option>
														</select>
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.property_type_id }"
																id="basic-addon2"><i v-if="!status"
																	data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'property_type_id')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i></span>
														</div>
													</div>
													<span v-if="property.errors.property_type_id"
														class="invalid-feedback" style="display:block;">{{
															property.errors.property_type_id[0] }}</span>
												</td>
												<td>
													<div class="input-group">
														<input type="text" class="form-control "
															placeholder="Property Description"
															:class="{ 'is-invalid': property.errors.property_description }"
															v-model="property.property_description"
															style="width: 155px;" maxlength="255" />
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.property_description }"
																id="basic-addon2"><i v-if="!status"
																	data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'property_description')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i></span>
														</div>
													</div>
													<span v-if="property.errors.property_description"
														class="invalid-feedback" style="display:block;">{{
															property.errors.property_description[0] }}</span>
												</td>
												<td>
													<template v-if="isWeightBasedProperty(property)">
														<div class="d-flex align-items-center gap-1 flex-wrap">
															<div :class="property.amount_input_group" class="flex-grow-1" style="min-width: 80px;">
																<input type="text" class="form-control" placeholder="Kg"
																	:class="{ 'is-invalid': property.errors.kilogram }"
																	v-model="property.kilogram" :style="property.amount_width"
																	@keypress="isNumber($event)" @copy.prevent @paste.prevent />
																<div class="input-group-append" :style="property.amount_display">
																	<span class="input-group-text" :class="{ 'is-invalid': property.errors.kilogram }">
																		<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
																			@click="getPropertyFieldHistory(property, 'kilogram')"
																			class="ri-history-line fs-18 lh-1-2 text-primary"></i>
																	</span>
																</div>
															</div>
															<div :class="property.amount_input_group" class="flex-grow-1" style="min-width: 80px;">
																<input type="text" class="form-control" placeholder="Gm"
																	:class="{ 'is-invalid': property.errors.grams }"
																	v-model="property.grams" :style="property.amount_width"
																	@keypress="isNumber($event)" @copy.prevent @paste.prevent />
																<div class="input-group-append" :style="property.amount_display">
																	<span class="input-group-text" :class="{ 'is-invalid': property.errors.grams }">
																		<i v-if="!status" data-bs-toggle="modal" data-bs-target="#exampleModal"
																			@click="getPropertyFieldHistory(property, 'grams')"
																			class="ri-history-line fs-18 lh-1-2 text-primary"></i>
																	</span>
																</div>
															</div>
														</div>
														<span v-if="property.errors.kilogram" class="invalid-feedback d-block">{{ property.errors.kilogram[0] }}</span>
														<span v-if="property.errors.grams" class="invalid-feedback d-block">{{ property.errors.grams[0] }}</span>
													</template>
													<template v-else-if="isQuantityOnlyProperty(property)">
														<input type="number" class="form-control" placeholder="Quantity (in numbers)"
															:class="{ 'is-invalid': property.errors.grams }"
															v-model.number="property.grams" style="width: 120px;" min="1" step="1"
															@keypress="isNumber($event)" @copy.prevent @paste.prevent />
														<span v-if="property.errors.grams" class="invalid-feedback d-block">{{ property.errors.grams[0] }}</span>
													</template>
													<template v-else>
														<span class="text-muted small">—</span>
													</template>
												</td>
												<td>
													<div class="input-group">
														<select class="form-control"
															:class="{ 'is-invalid': property.errors.siezed_property_available }"
															v-model="property.siezed_property_available"
															@change="showColumn('remarks', property.siezed_property_available, property)">
															<option value="1">Yes</option>
															<option value="0">No</option>
														</select>
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.siezed_property_available }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'siezed_property_available')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.siezed_property_available"
														class="invalid-feedback" style="display:block;">{{
															property.errors.siezed_property_available[0] }}</span>
												</td>
												<td>
													<div :class="property.remarks_input_group">
														<input type="text" class="form-control" placeholder="Remarks"
															:class="{ 'is-invalid': property.errors.remarks_if_property_not_available }"
															v-model="property.remarks_if_property_not_available"
															:disabled="property.remarks_status" />
														<div class="input-group-append"
															:style="property.remarks_display">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.remarks_if_property_not_available }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'remarks_if_property_not_available')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.remarks_if_property_not_available"
														class="invalid-feedback" style="display:block;">{{
															property.errors.remarks_if_property_not_available[0] }}</span>
												</td>
												<td>
													<div class="input-group">
														<select class="form-control"
															:class="{ 'is-invalid': property.errors.valuable_non_valuable }"
															v-model="property.valuable_non_valuable"
															@change="showProperty('valuable', property.valuable_non_valuable, property)">
															<option value="">Select Valuable / Non Valuable</option>
															<option value="Valuable">Valuable</option>
															<option value="Non-Valuable">Non-Valuable</option>
														</select>
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.valuable_non_valuable }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'valuable_non_valuable')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.valuable_non_valuable"
														class="invalid-feedback" style="display:block;">{{
															property.errors.valuable_non_valuable[0] }}</span>
												</td>
												<td>
													<div :class="property.property_value_input_group">
														<input type="number" min="0"
															oninput="validity.valid||(value='');" class="form-control"
															placeholder="Property Value"
															:class="{ 'is-invalid': property.errors.property_value }"
															:style="property.property_value_width"
															v-model="property.property_value"
															:disabled="property.property_value_status" />
														<div class="input-group-append"
															:style="property.property_value_display">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.property_value }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'property_value')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.property_value" class="invalid-feedback"
														style="display:block;">{{ property.errors.property_value[0]
														}}</span>
												</td>
												<td>
													<div class="input-group">
														<select class="form-control"
															:class="{ 'is-invalid': property.errors.disposed }"
															v-model="property.disposed"
															@change="getDisposedStatus1('property_disposed', property.disposed, property)">
															<option value="1">Yes</option>
															<option value="0">No</option>
														</select>
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.disposed }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'disposed')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.disposed" class="invalid-feedback"
														style="display:block;">{{ property.errors.disposed[0] }}</span>
												</td>
												<td>
													<div :class="property.disposed_input_group">
														<select class="form-control"
															v-model="property.property_disposal_stage_id"
															:class="{ 'is-invalid': property.errors.property_disposal_stage_id }"
															:style="property.disposed_width"
															:disabled="property.disposed_status"
															@change="getDisposedStatus('auction', property.property_disposal_stage_id, property)">
															<option value="null">Select Property Disposal</option>
															<option v-for="property_disposal, key in getFilteredPropertyDisposals(property)"
																:key="key"
																:value="property_disposal.property_disposal_stage_id">
																{{ property_disposal.property_disposal_stage }}</option>
														</select>
														<div class="input-group-append"
															:style="property.disposed_display">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.property_disposal_stage_id }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'property_disposal_stage_id')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.property_disposal_stage_id"
														class="invalid-feedback" style="display:block;">{{
															property.errors.property_disposal_stage_id[0] }}</span>
												</td>
												<td>
													<div class="input-group">
														<input type="date" class="form-control"
															:class="{ 'is-invalid': property.errors.disposed_date }"
															v-model="property.disposed_date" max="9999-12-31" />
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.disposed_date }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'disposed_date')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.disposed_date" class="invalid-feedback"
														style="display:block;">{{ property.errors.disposed_date[0]
														}}</span>
												</td>
												<td>
													<div class="input-group">
														<input type="text" class="form-control"
															placeholder="Incharge Officer"
															:class="{ 'is-invalid': property.errors.officer_incharge }"
															style="width: 124px;" v-model="property.officer_incharge" />
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.officer_incharge }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'officer_incharge')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.officer_incharge"
														class="invalid-feedback" style="display:block;">{{
															property.errors.officer_incharge[0] }}</span>
												</td>
												<td>
													<div class="input-group">
														<input type="text" class="form-control"
															placeholder="Remarks By Incharge Officer"
															:class="{ 'is-invalid': property.errors.instructions_by_officer }"
															v-model="property.instructions_by_officer" />
														<div class="input-group-append">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.instructions_by_officer }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'instructions_by_officer')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.instructions_by_officer"
														class="invalid-feedback" style="display:block;">{{
															property.errors.instructions_by_officer[0] }}</span>
												</td>
												<td>
													<div :class="property.auction_value_input_group">
														<input type="number" class="form-control"
															placeholder="Auction Value"
															oninput="validity.valid||(value='');"
															:style="property.auction_value_width"
															:class="{ 'is-invalid': property.errors.auction_sold_value }"
															v-model="property.auction_sold_value"
															:disabled="property.auction_status" />
														<div class="input-group-append"
															:style="property.auction_value_display">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.auction_sold_value }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'auction_sold_value')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>
													</div>
													<span v-if="property.errors.auction_sold_value"
														class="invalid-feedback" style="display:block;">{{
															property.errors.auction_sold_value[0] }}</span>
												</td>
												<td>
													<div :class="property.auction_value_input_group">
														<input type="date" class="form-control"
															:class="{ 'is-invalid': property.errors.auction_sold_date }"
															v-model="property.auction_sold_date" max="9999-12-31"
															:disabled="property.auction_status" />
														<div class="input-group-append"
															:style="property.auction_value_display">
															<span class="input-group-text"
																:class="{ 'is-invalid': property.errors.auction_sold_date }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'auction_sold_date')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>

													</div>
													<span v-if="property.errors.auction_sold_date"
														class="invalid-feedback" style="display:block;">{{
															property.errors.auction_sold_date[0] }}</span>
												</td>
												<td>
													<div class="input-group">
														<div class="mb-1">
															<input type="file" class="form-control"
																:class="{ 'is-invalid': property.errors.property_photo }"
																ref="file"
																@change="getPropertyPhoto($event, property)" />

														</div>

														<div class="input-group-append">
															<span class="input-group-text border-left-0"
																:class="{ 'is-invalid': property.errors.property_photo }"
																id="basic-addon2">
																<i v-if="!status" data-bs-toggle="modal"
																	data-bs-target="#exampleModal"
																	@click="getPropertyFieldHistory(property, 'property_photo')"
																	class="ri-history-line fs-18 lh-1-2 text-primary"></i>
															</span>
														</div>


													</div>
													<div v-if="property.property_photo">
														<a v-if="property?.property_photo_path && !property?.property_photo_path.endsWith('/')"
															:href="property?.property_photo_path" target="_blank">{{
																property.property_photo }}</a>
														<a v-else :href="property?.url" target="_blank">{{
															property.property_photo_name }}</a>
														<a href="javascript:void(0)" class="text-danger mx-2"
															@click="deletePropertyImage(property)"><i
																class="ri-close-circle-line"></i></a>
													</div>
													<span v-if="property.errors.property_photo" class="invalid-feedback"
														style="display:block;">{{ property.errors.property_photo[0]
														}}</span>
												</td>
												<td class="text-center align-middle col-fsl-actions">
													<div v-if="property.property_id" class="d-flex flex-column align-items-center gap-1">
														<a href="javascript:void(0)" class="text-primary" title="Edit FSL"
															@click="openSendFSL(property)">
															<i class="ri-pencil-line fs-16"></i>
														</a>
														<a href="javascript:void(0)" class="text-info" title="View FSL"
															@click="openSectionView('fsl', property)">
															<i class="ri-eye-line fs-16"></i>
														</a>
													</div>
													<span v-else class="text-muted small">Save first</span>
												</td>
												<td class="text-center align-middle col-court-actions">
													<div v-if="property.property_id" class="d-flex flex-column align-items-center gap-1">
														<a href="javascript:void(0)" class="text-primary" title="Edit Court"
															@click="openSendCourt(property)">
															<i class="ri-pencil-line fs-16"></i>
														</a>
														<a href="javascript:void(0)" class="text-info" title="View Court"
															@click="openSectionView('court', property)">
															<i class="ri-eye-line fs-16"></i>
														</a>
													</div>
													<span v-else class="text-muted small">Save first</span>
												</td>
												<td class="text-center align-middle col-current-location">
													<span v-if="property.property_id">{{ getCurrentLocationText(property) }}</span>
													<span v-else class="text-muted small">—</span>
												</td>
												<td class="text-center align-middle col-shelf">
													<div v-if="property.property_id && canEditShelf(property)" class="d-flex flex-column align-items-center gap-1">
														<a href="javascript:void(0)" class="text-primary" title="Update Shelf"
															@click="openShelfModal(property)">
															<i class="ri-pencil-line fs-14"></i>
														</a>
														<a href="javascript:void(0)" class="text-info" title="View Shelf"
															@click="openShelfViewModal(property)">
															<i class="ri-eye-line fs-14"></i>
														</a>
													</div>
													<span v-else class="text-muted small">-</span>
												</td>
												<td class="text-center align-middle col-destroyed-actions">
													<div v-if="property.property_id" class="d-flex flex-column align-items-center gap-1">
														<a href="javascript:void(0)" class="text-primary" title="Edit Destroyed"
															@click="openDestroy(property)">
															<i class="ri-pencil-line fs-16"></i>
														</a>
														<a href="javascript:void(0)" class="text-info" title="View Destroyed"
															@click="openSectionView('destroyed', property)">
															<i class="ri-eye-line fs-16"></i>
														</a>
													</div>
													<span v-else class="text-muted small">Save first</span>
												</td>
												<td class="text-center">
													<nav>
														<a href="javascript:void(0)" class="text-danger"
															@click="deleteRow(property, key)"><i
																class="ri-delete-bin-6-line fs-18 lh-1"></i></a>
													</nav>
												</td>
											</tr>
											<!-- end -->


										</tbody>

									</table>
								</div>
								<span class="text-danger small" v-if="errors.properties">{{ errors?.properties[0]
									}}</span>
							</div>
						</div>
					</div>

					<div class="mb-3">
						<h5 class="mb-2">FSL Details</h5>
						<div class="table-responsive">
							<table class="table table-bottom-border text-nowrap mb-0 details-table">
								<thead>
									<tr style="background-color: #f5f5f5;">
										<th class="w-pf-no">PF No</th>
										<th class="w-item">Item</th>
										<th>Partial</th>
										<th class="w-date">FSL Sending Date</th>
										<th class="w-ack">Acknowledgement No</th>
										<th class="w-date">FSL Received Date</th>
										<th>Remarks</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, idx) in getFslDetailsRows()" :key="`fsl-row-${idx}`">
										<td>{{ form.pf_number || '-' }}</td>
										<td>{{ row.item || '-' }}</td>
										<td>{{ row.partial_flag || '-' }}</td>
										<td>{{ row.date_sent || '-' }}</td>
										<td>{{ row.acknowledgement_no || '-' }}</td>
										<td>{{ row.date_received || '-' }}</td>
										<td>{{ row.remarks || '-' }}</td>
									</tr>
									<tr v-if="!getFslDetailsRows().length">
										<td colspan="7" class="text-center text-muted">No FSL details available.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="mb-3">
						<h5 class="mb-2">Court Details</h5>
						<div class="table-responsive">
							<table class="table table-bottom-border text-nowrap mb-0 details-table">
								<thead>
									<tr style="background-color: #f5f5f5;">
										<th class="w-pf-no">PF No</th>
										<th class="w-item">Item</th>
										<th>Partial</th>
										<th class="w-date">Court Sending Date</th>
										<th class="w-name">Sent PS Person</th>
										<th class="w-name">Received Person (Court)</th>
										<th>PR No.</th>
										<th>Remarks</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, idx) in getCourtDetailsRows()" :key="`court-row-${idx}`">
										<td>{{ form.pf_number || '-' }}</td>
										<td>{{ row.item || '-' }}</td>
										<td>{{ row.partial_flag || '-' }}</td>
										<td>{{ row.date_sent || '-' }}</td>
										<td>{{ row.submitting_officer_name || '-' }}</td>
										<td>{{ row.receiving_court_staff_name || '-' }}</td>
										<td>{{ row.pr_number || '-' }}</td>
										<td>{{ row.remarks || '-' }}</td>
									</tr>
									<tr v-if="!getCourtDetailsRows().length">
										<td colspan="8" class="text-center text-muted">No Court details available.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="mb-1">
						<h5 class="mb-2">Destroyed Details</h5>
						<div class="table-responsive">
							<table class="table table-bottom-border text-nowrap mb-0 details-table">
								<thead>
									<tr style="background-color: #f5f5f5;">
										<th class="w-pf-no">PF No</th>
										<th class="w-item">Item</th>
										<th class="w-date">Date of Destruction</th>
										<th class="w-name">Authority Name</th>
										<th class="w-name">Authority Designation</th>
										<th>Remarks</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, idx) in getDestroyedDetailsRows()" :key="`destroyed-row-${idx}`">
										<td>{{ form.pf_number || '-' }}</td>
										<td>{{ row.item || '-' }}</td>
										<td>{{ row.destruction_date || '-' }}</td>
										<td>{{ row.ordering_authority || '-' }}</td>
										<td>{{ row.ordering_authority_designation || '-' }}</td>
										<td>{{ row.remarks || '-' }}</td>
									</tr>
									<tr v-if="!getDestroyedDetailsRows().length">
										<td colspan="6" class="text-center text-muted">No Destroyed details available.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="card-footer text-end">
					<router-link v-if="status" to="/muddemal" type="button" class="btn btn-danger me-2"><i
							class="ri-arrow-left-line me-1"></i>Back</router-link>
					<button class="btn btn-primary" type="button" @click="updateForms()">
						<span> <i class="ri-save-line me-1"></i> Update </span>
					</button>
				</div>
			</div>
		</div>
	</div>

	<SendToFSLDialog
		ref="sendFSLDialog"
		:property="selectedPropertyForAction"
		:available-quantity="actionAvailableQuantity"
		:server-available-quantity="actionServerAvailableQuantity"
		:movements="actionMovements"
		:fsl-batches="actionFslBatches"
		@refresh="onMovementDialogRefresh"
	/>
	<ReceiveFromFSLDialog
		ref="receiveFSLDialog"
		:property="selectedPropertyForAction"
		:fsl-batches="actionFslBatches"
		:current-p-s-quantity="actionPSQuantity"
		:current-f-s-l-quantity="actionFSLQuantity"
		@refresh="onMovementDialogRefresh"
	/>
	<SendToCourtDialog
		ref="sendCourtDialog"
		:property="selectedPropertyForAction"
		:available-quantity="actionAvailableQuantity"
		:movements="actionMovements"
		@refresh="onMovementDialogRefresh"
	/>
	<DestroyPropertyDialog
		ref="destroyDialog"
		:property="selectedPropertyForAction"
		:available-quantity="actionAvailableQuantity"
		:destruction-details="actionDestructionDetails"
		@refresh="onMovementDialogRefresh"
	/>

	<div class="modal fade" id="sectionViewModal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">{{ sectionViewState.title }}</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="table-responsive">
						<table class="table table-striped text-nowrap mb-0">
							<thead>
								<tr v-if="sectionViewState.section === 'fsl'">
									<th>PF No</th>
									<th>Item</th>
									<th>Partial</th>
									<th>FSL Sending Date</th>
									<th>Acknowledgement No</th>
									<th>FSL Received Date</th>
									<th>Remarks</th>
								</tr>
								<tr v-else-if="sectionViewState.section === 'court'">
									<th>PF No</th>
									<th>Item</th>
									<th>Partial</th>
									<th>Court Sending Date</th>
									<th>Sent PS Person</th>
									<th>Received Person (Court)</th>
									<th>PR No.</th>
									<th>Remarks</th>
								</tr>
								<tr v-else>
									<th>PF No</th>
									<th>Item</th>
									<th>Date of Destruction</th>
									<th>Authority Name</th>
									<th>Authority Designation</th>
									<th>Remarks</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="sectionViewState.section === 'fsl'" v-for="(row, idx) in sectionViewState.rows" :key="`view-fsl-row-${idx}`">
									<td>{{ row.pf_no || '-' }}</td>
									<td>{{ row.item || '-' }}</td>
									<td>{{ row.partial_flag || '-' }}</td>
									<td>{{ row.date_sent || '-' }}</td>
									<td>{{ row.acknowledgement_no || '-' }}</td>
									<td>{{ row.date_received || '-' }}</td>
									<td>{{ row.remarks || '-' }}</td>
								</tr>
								<tr v-else-if="sectionViewState.section === 'court'" v-for="(row, idx) in sectionViewState.rows" :key="`view-court-row-${idx}`">
									<td>{{ row.pf_no || '-' }}</td>
									<td>{{ row.item || '-' }}</td>
									<td>{{ row.partial_flag || '-' }}</td>
									<td>{{ row.date_sent || '-' }}</td>
									<td>{{ row.submitting_officer_name || '-' }}</td>
									<td>{{ row.receiving_court_staff_name || '-' }}</td>
									<td>{{ row.pr_number || '-' }}</td>
									<td>{{ row.remarks || '-' }}</td>
								</tr>
								<tr v-else v-for="(row, idx) in sectionViewState.rows" :key="`view-destroyed-row-${idx}`">
									<td>{{ row.pf_no || '-' }}</td>
									<td>{{ row.item || '-' }}</td>
									<td>{{ row.destruction_date || '-' }}</td>
									<td>{{ row.ordering_authority || '-' }}</td>
									<td>{{ row.ordering_authority_designation || '-' }}</td>
									<td>{{ row.remarks || '-' }}</td>
								</tr>
								<tr v-if="!sectionViewState.rows.length">
									<td colspan="7" class="text-center text-muted">No records available.</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="shelfUpdateModal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Update Shelf</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="mb-1">
						<label class="form-label">Mention Shelf No</label>
						<input
							type="text"
							class="form-control"
							placeholder="Enter shelf number"
							v-model="shelfForm.ps_shelf_no"
						/>
						<small class="text-muted">Leave empty to clear shelf number.</small>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
					<button type="button" class="btn btn-primary" @click="submitShelfForm">Save</button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="shelfViewModal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Shelf Details</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="mb-0">
						<label class="form-label">Shelf No</label>
						<input type="text" class="form-control" :value="shelfViewState.ps_shelf_no" readonly />
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>

	<!-- model -->
	<div class="modal modal-lg fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
		aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Field History</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="table-responsive mb-2">
						<input v-if="property_history_status" type="email" class="form-control mb-2"
							id="exampleFormControlInput1" placeholder="Search" v-model="history_meta.search"
							@keypress="search()" />

						<input v-else type="email" class="form-control mb-2" id="exampleFormControlInput1"
							placeholder="Search" v-model="muddemal_meta.search" @keypress="search()" />
						<table class="table table-striped text-nowrap table-hover table-bottom-border mb-0">
							<thead>
								<tr style="background-color: #f5f5f5;">
									<th class="text-center">Sl No.</th>
									<th>Updated Value</th>
									<th>Old Value</th>
									<th>Edited User</th>
									<th>Date & Time</th>
								</tr>
							</thead>
							<tbody v-if="property_history_status">
								<tr v-for="value, key in field_history" :key="key">
									<td v-if="property_history_status" class="text-center">{{ history_meta.from + key }}
									</td>
									<td v-else class="text-center">{{ muddemal_meta.from + key }}</td>
									<td> {{ value.new_value }} </td>
									<td> {{ value.old_value }} </td>
									<td> {{ value.edited_by?.name }} </td>
									<td> {{ changeDateFormat(value.edited_date_time) }} </td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr v-for="value, key in muddemal_history" :key="key">
									<td class="text-center">{{ key + 1 }}</td>
									<td> {{ value.new_value }} </td>
									<td> {{ value.old_value }} </td>
									<td> {{ value.edited_by?.name }} </td>
									<td> {{ changeDateFormat(value.edited_date_time) }} </td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="property_history_status" class="card-footer">
						<Pagination :maxPage="history_meta.maxPage" :totalPages="history_meta.lastPage"
							:currentPage="history_meta.page" @pagechanged="onPageChange" />
					</div>
					<div v-else class="card-footer">
						<Pagination :maxPage="muddemal_meta.maxPage" :totalPages="muddemal_meta.lastPage"
							:currentPage="muddemal_meta.page" @pagechanged="onPageChange" />
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import Search from "@/components/Search.vue";
import Pagination from "@/components/Pagination.vue";
import SendToFSLDialog from "@/components/SendToFSLDialog.vue";
import ReceiveFromFSLDialog from "@/components/ReceiveFromFSLDialog.vue";
import SendToCourtDialog from "@/components/SendToCourtDialog.vue";
import DestroyPropertyDialog from "@/components/DestroyPropertyDialog.vue";
import moment from "moment";
export default {
	name: "MuddemaalEdit",
	components: {
		Search,
		Pagination,
		SendToFSLDialog,
		ReceiveFromFSLDialog,
		SendToCourtDialog,
		DestroyPropertyDialog
	},
	data() {
		return {
			status: true,
			is_disabled: true,
			selected_division: "",
			form: {
				muddemal_id: "",
				pf_number: "",
				pf_date: "",
				year: "",
				crime_no_sec: "",
				number_type: 'CRIME_NO',
				section_of_law: "",
				investigation_officer: "",
				seizing_officer: "",
				crime_year: "",
				siezed_from_whom: "",
				siezed_from_place: "",
				cc_sc_no: "",
				case_stage_id: "",
				pr_no: "",
				pr_date: "",
				holding_officer: "",
				police_station_id: "",
				sub_division_id: "",
				circle_id: "",
				transferred_ps_id: "",
				properties: [],
				deleted_properties: [],
			},
			field_history: [],
			formStatus: true,
			errors: [],
			case_stages: [],
			police_stations: [],
			all_police_stations: [],
			sub_divisions: [],
			circles: [],
			property_types: [],
			property_disposals: [],
			auction: false,
			years: [],
			history_meta: {
				search: "",
				order_by: "asc",
				keyword: "old_value",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				property_id: [],
				field: '',
				muddemal_id: "",
			},

			muddemal_meta: {
				search: "",
				order_by: "asc",
				keyword: "old_value",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				field: '',
				muddemal_id: "",
			},
			property: {},
			muddemal_history: [],
			muddemal_history_status: false,
			property_history_status: false,
			number_type_label: 'Crime No.',
			selectedPropertyForAction: null,
			actionAvailableQuantity: 0,
			actionServerAvailableQuantity: null,
			actionFslBatches: [],
			actionMovements: [],
			actionDestructionDetails: [],
			actionPSQuantity: 0,
			actionFSLQuantity: 0,
			propertyMovementCache: {},
			sectionViewState: {
				title: "Details",
				section: "",
				rows: []
			},
			shelfForm: {
				property_id: null,
				property_description: "",
				ps_shelf_no: ""
			},
			shelfViewState: {
				ps_shelf_no: ""
			}
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (to.name == "MuddemaalCreate") {
				vm.$refs.pf_number.focus();
				if (!vm.form.properties.length) {
					vm.addProperty();
				}
			} else {
				vm.status = false;
				let uri = { uri: "getMuddemal", data: { muddemal_id: to.params.muddemal_id } };
				vm.$store
					.dispatch("post", uri)
					.then(function (response) {
						vm.form = response.data.data;
						vm.form.circle_id = vm.form.police_Station?.circle?.circle_id ?? '';
						vm.getSubDivisionAndCircle(vm.form.police_station_id);
						vm.form.deleted_properties = [];
						if (!vm.form.properties.length) {
							vm.addProperty();
						}

						if (vm.form.properties.length) {
							vm.form.properties.filter(function (ele) {
								if (ele.disposed) {
									vm.property_disposed = true;
								}
								const typeName = (ele.property_type?.property_type || '').toString().toLowerCase();
								const weightKw = ['drug', 'gold', 'silver', 'diamond', 'precious metal', 'narcotic', 'grams', 'contraband'];
								const quantityOnlyKw = ['vehicle', 'laptop', 'mobile', 'electronic', 'cash', 'others'];
								const isWeight = weightKw.some(k => typeName.includes(k));
								const isQuantityOnly = quantityOnlyKw.some(k => typeName.includes(k));
								if (isWeight) {
									ele.amount_input_group = 'input-group'
									ele.amount_width = 'width:90px'
									ele.amount_display = 'display:block'
									ele.amount_status = false
								} else if (isQuantityOnly) {
									ele.amount_input_group = ''
									ele.amount_display = 'display:none'
									ele.amount_width = 'width:135px'
									ele.amount_status = true
									ele.kilogram = ''
								} else {
									ele.amount_input_group = ''
									ele.amount_display = 'display:none'
									ele.amount_width = 'width:135px'
									ele.amount_status = true
									ele.kilogram = ''
									ele.grams = ''
								}
								if (ele.siezed_property_available == 0) {
									ele.remarks_input_group = 'input-group'
									ele.remarks_display = 'display:block'
									ele.remarks_status = false
								} else {
									ele.remarks_input_group = ''
									ele.remarks_display = 'display:none'
									ele.remarks_status = true
								}

								if (ele.valuable_non_valuable == 'Valuable') {
									ele.property_value_input_group = 'input-group'
									ele.property_value_display = 'display:block'
									ele.property_value_width = 'width:90px'
									ele.property_value_status = false
								} else {
									ele.property_value_input_group = ''
									ele.property_value_display = 'display:none'
									ele.property_value_width = 'width:133px'
									ele.property_value_status = true
								}

								if (ele.disposed == 1 || ele.disposed != '') {
									ele.disposed_input_group = 'input-group'
									ele.disposed_display = 'display:block'
									ele.disposed_width = 'width:155px'
									ele.disposed_status = false
								} else {
									ele.disposed_input_group = ''
									ele.disposed_display = 'display:none'
									ele.disposed_width = 'width:200px'
									ele.disposed_status = true
									ele.auction_sold_value = null;
									ele.auction_sold_date = null;
								}
								if (ele.property_disposal_stage_id || ele.disposed != 0 || ele.disposed != '') {
									ele.auction_value_input_group = 'input-group'
									ele.auction_value_display = 'display:block'
									ele.auction_value_width = 'width:80px'
									const disposalStageName = ele.property_disposal_stage && ele.property_disposal_stage.property_disposal_stage
										? ele.property_disposal_stage.property_disposal_stage
										: null;
									if (ele.property_disposal_stage_id != null && disposalStageName === "Auction") {
										ele.auction_status = false
									} else {
										ele.auction_status = true;
									}

								} else {
									ele.auction_value_input_group = ''
									ele.auction_value_display = 'display:none'
									ele.auction_value_width = 'width:125px'
									ele.auction_status = true
									ele.auction_sold_value = null;
									ele.auction_sold_date = null;

								}
							});
						}
						vm.refillPropertyMovementCache();
					})
					.catch(function (error) {
						const resp = error && error.response ? error.response : {};
						vm.errors = (resp.data && resp.data.errors) || {};
						const msg = (resp.data && resp.data.message) || error.message || "Failed to load muddemal details.";
						vm.$store.dispatch("error", msg);
					});
			}
		});
	},
	mounted() {
		let vm = this;
		vm.getCaseStages();
	},

	watch: {
		"form.number_type": function (val) {
			switch (val) {
				case 'CRIME_NO': this.number_type_label = 'Crime No.';
					break;
				case 'UDR_NO': this.number_type_label = 'UDR No.';
					break;
				case 'NCR_NO': this.number_type_label = 'NCR No.';
					break;
				case 'C_MISC': this.number_type_label = 'C Misc. No.';
					break;
				default: this.number_type_label = 'Crime No.'
			}
		}
	},
	methods: {
		getQuantityFromForm(property) {
			if (!property) return 0;
			if (this.isWeightBasedProperty(property)) {
				const kg = parseFloat(property.kilogram) || 0;
				const g = parseFloat(property.grams) || 0;
				return kg * 1000 + g;
			}
			if (this.isQuantityOnlyProperty(property)) {
				return Math.max(0, parseInt(property.grams, 10) || 0);
			}
			return 0;
		},
		async loadPropertyMovementData(propertyId) {
			const response = await this.$store.dispatch('post', {
				uri: 'getPropertyWithMovements',
				data: { property_id: propertyId }
			});
			const data = response.data;
			const breakdown = data.location_breakdown || [];
			const psLoc = breakdown.find(l => l.type === 'ps');
			const fslLoc = breakdown.find(l => l.type === 'fsl');
			const availablePSQuantity = psLoc ? Number(psLoc.quantity) || 0 : 0;
			const allocated = breakdown
								.filter(l => l.type !== 'ps')
								.reduce((sum, l) => sum + (Number(l.quantity) || 0), 0);
			return {
				availablePSQuantity,
				availableFSLQuantity: fslLoc ? Number(fslLoc.quantity) || 0 : 0,
				fsl_batches: data.fsl_batches || [],
				location_breakdown: breakdown,
				destruction_details: data.destruction_details || [],
				allocated,
				movements: data.movements || []
			};
		},
		async openSendFSL(property) {
			if (!property || !property.property_id) return;
			try {
				const data = await this.loadPropertyMovementData(property.property_id);
				this.selectedPropertyForAction = property;
				this.actionAvailableQuantity = Math.max(0, data.availablePSQuantity || 0);
				this.actionServerAvailableQuantity = data.availablePSQuantity;
				this.actionFslBatches = data.fsl_batches || [];
				this.actionMovements = data.movements || [];
				this.$nextTick(() => this.$refs.sendFSLDialog?.open());
			} catch (e) {
				console.error('Error loading property movements:', e);
				this.$store.dispatch('error', e.response?.data?.message || 'Failed to load property data');
			}
		},
		async openSendCourt(property) {
			if (!property || !property.property_id) return;
			try {
				const data = await this.loadPropertyMovementData(property.property_id);
				const courtLocked = (data.movements || []).some((movement) => {
					if (movement.type !== 'court_send') return false;
					const prNo = movement.court_submission?.pr_number;
					return !!String(prNo || '').trim();
				});
				if (courtLocked) {
					this.$store.dispatch('info', 'PR No. is already entered for this property. Court details are locked.');
					return;
				}
				this.selectedPropertyForAction = property;
				this.actionAvailableQuantity = Math.max(0, data.availablePSQuantity || 0);
				this.actionMovements = data.movements || [];
				this.$nextTick(() => this.$refs.sendCourtDialog?.open());
			} catch (e) {
				console.error('Error loading property movements:', e);
				this.$store.dispatch('error', e.response?.data?.message || 'Failed to load property data');
			}
		},
		async openReceiveFSL(property) {
			if (!property || !property.property_id) return;
			try {
				const data = await this.loadPropertyMovementData(property.property_id);
				this.selectedPropertyForAction = property;
				this.actionFslBatches = data.fsl_batches || [];
				const formTotal = this.getQuantityFromForm(property);
				this.actionPSQuantity = Math.max(0, formTotal - (data.allocated || 0));
				this.actionFSLQuantity = data.availableFSLQuantity || 0;
				this.$nextTick(() => this.$refs.receiveFSLDialog?.open());
			} catch (e) {
				console.error('Error loading property movements:', e);
				this.$store.dispatch('error', e.response?.data?.message || 'Failed to load property data');
			}
		},
		async openDestroy(property) {
			if (!property || !property.property_id) return;
			try {
				const data = await this.loadPropertyMovementData(property.property_id);
				this.selectedPropertyForAction = property;
				this.actionAvailableQuantity = Math.max(0, data.availablePSQuantity || 0);
				this.actionDestructionDetails = data.destruction_details || [];
				this.$nextTick(() => this.$refs.destroyDialog?.open());
			} catch (e) {
				console.error('Error loading property movements:', e);
				this.$store.dispatch('error', e.response?.data?.message || 'Failed to load property data');
			}
		},
		onMovementDialogRefresh() {
			this.selectedPropertyForAction = null;
			this.actionAvailableQuantity = 0;
			this.actionServerAvailableQuantity = null;
			this.actionFslBatches = [];
			this.actionMovements = [];
			this.actionDestructionDetails = [];
			this.actionPSQuantity = 0;
			this.actionFSLQuantity = 0;
			const uri = { uri: "getMuddemal", data: { muddemal_id: this.form.muddemal_id } };
			this.$store.dispatch("post", uri).then((response) => {
				this.form = response.data.data;
				this.form.deleted_properties = this.form.deleted_properties || [];
				this.refillPropertyMovementCache();
			}).catch(() => {});
		},
		async refillPropertyMovementCache() {
			const cache = {};
			for (const p of this.form.properties || []) {
				if (p.property_id) {
					try {
						const data = await this.loadPropertyMovementData(p.property_id);
						cache[p.property_id] = {
							availablePSQuantity: data.availablePSQuantity,
							availableFSLQuantity: data.availableFSLQuantity,
							fsl_batches: data.fsl_batches || [],
							location_breakdown: data.location_breakdown || [],
							destruction_details: data.destruction_details || [],
							movements: data.movements || [],
							allocated: data.allocated || 0
						};
					} catch (e) {
						cache[p.property_id] = {
							availablePSQuantity: 0,
							availableFSLQuantity: 0,
							fsl_batches: [],
							location_breakdown: [],
							destruction_details: [],
							movements: [],
							allocated: 0
						};
					}
				}
			}
			this.propertyMovementCache = cache;
		},
		getPropertyLocationSnapshot(property) {
			if (!property || !property.property_id) return [];
			return this.propertyMovementCache[property.property_id]?.location_breakdown || [];
		},
		getCurrentLocationText(property) {
			const locations = this.getPropertyLocationSnapshot(property);
			const getQty = (type) => Number(locations.find((l) => l.type === type)?.quantity || 0);
			const hasLocation = (type) => !!locations.find((l) => l.type === type);
			if (getQty('fsl') > 0) return 'FSL';
			if (getQty('court') > 0) return 'Court';
			if (getQty('ps') > 0) return 'Police Station';
			if (getQty('destroyed') > 0) return 'Others';
			if (getQty('others') > 0) return 'Others';
			// Keep location as Police Station if PS entry exists, even when quantity is zero.
			if (hasLocation('ps')) return 'Police Station';
			return '—';
		},
		getCurrentShelfText(property) {
			const locations = this.getPropertyLocationSnapshot(property);
			const psLoc = locations.find((l) => l.type === 'ps');
			const current = this.getCurrentLocationText(property);
			if (current !== 'Police Station') return '';
			return psLoc?.ps_shelf_no || '';
		},
		canEditShelf(property) {
			return this.getCurrentLocationText(property) === 'Police Station';
		},
		openShelfModal(property) {
			if (!property?.property_id) return;
			if (!this.canEditShelf(property)) {
				this.$store.dispatch('error', 'Shelf can be edited only when current location is Police Station');
				return;
			}
			const currentShelf = this.getCurrentShelfText(property);
			this.shelfForm = {
				property_id: property.property_id,
				property_description: property.property_description || "",
				ps_shelf_no: currentShelf || ''
			};
			this.$nextTick(() => {
				const modalElement = document.getElementById('shelfUpdateModal');
				if (modalElement && window.bootstrap) {
					const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
					modal.show();
				}
			});
		},
		openShelfViewModal(property) {
			if (!property?.property_id) return;
			this.shelfViewState.ps_shelf_no = this.getCurrentShelfText(property) || '-';
			this.$nextTick(() => {
				const modalElement = document.getElementById('shelfViewModal');
				if (modalElement && window.bootstrap) {
					const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
					modal.show();
				}
			});
		},
		async submitShelfForm() {
			if (!this.shelfForm.property_id) return;
			try {
				await this.$store.dispatch('post', {
					uri: 'updatePropertyLocation',
					data: {
						property_id: this.shelfForm.property_id,
						ps_shelf_no: this.shelfForm.ps_shelf_no || null
					}
				});
				this.$store.dispatch('success', 'Shelf updated successfully');
				const modalElement = document.getElementById('shelfUpdateModal');
				if (modalElement && window.bootstrap) {
					const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
					modal.hide();
				}
				this.onMovementDialogRefresh();
			} catch (e) {
				this.$store.dispatch('error', e.response?.data?.message || 'Failed to update shelf');
			}
		},
		getFslDetailsRows() {
			const rows = [];
			(this.form.properties || []).forEach((property) => {
				const cache = this.propertyMovementCache[property.property_id] || {};
				(cache.movements || []).forEach((movement) => {
					if (movement.type === 'fsl_send') {
						rows.push({
							item: property.property_description,
							partial_flag: movement.fsl_detail?.is_partial ? 'Yes' : 'No',
							date_sent: this.formatDateOnly(movement.fsl_detail?.date_sent || movement.movement_date),
							acknowledgement_no: movement.fsl_detail?.acknowledgement_no || '',
							date_received: this.formatDateOnly(movement.fsl_detail?.date_received),
							remarks: movement.remarks || ''
						});
					}
				});
			});
			return rows;
		},
		getCourtDetailsRows() {
			const rows = [];
			(this.form.properties || []).forEach((property) => {
				const cache = this.propertyMovementCache[property.property_id] || {};
				(cache.movements || []).forEach((movement) => {
					if (movement.type === 'court_send') {
						rows.push({
							item: property.property_description,
							partial_flag: movement.court_submission?.is_partial ? 'Yes' : 'No',
							date_sent: this.formatDateOnly(movement.court_submission?.date_sent || movement.movement_date),
							submitting_officer_name: movement.court_submission?.submitting_officer_name || '',
							receiving_court_staff_name: movement.court_submission?.receiving_court_staff_name || '',
							pr_number: movement.court_submission?.pr_number || '',
							remarks: movement.remarks || ''
						});
					}
				});
			});
			return rows;
		},
		getDestroyedDetailsRows() {
			const rows = [];
			(this.form.properties || []).forEach((property) => {
				const cache = this.propertyMovementCache[property.property_id] || {};
				(cache.destruction_details || []).forEach((detail) => {
					rows.push({
						item: property.property_description,
						destruction_date: this.formatDateOnly(detail.destruction_date),
						ordering_authority: detail.ordering_authority || '',
						ordering_authority_designation: detail.ordering_authority_designation || '',
						remarks: detail.remarks || ''
					});
				});
			});
			return rows;
		},
		formatDateOnly(value) {
			if (!value) return '-';
			const date = new Date(value);
			if (isNaN(date.getTime())) return value;
			return date.toLocaleDateString('en-US', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			});
		},
		openSectionView(section, property) {
			const rows = this.getSectionRowsForProperty(section, property);
			let title = 'Details';
			if (section === 'fsl') title = 'FSL Details';
			if (section === 'court') title = 'Court Details';
			if (section === 'destroyed') title = 'Destroyed Details';
			this.sectionViewState = { title, section, rows };
			this.$nextTick(() => {
				const modalElement = document.getElementById('sectionViewModal');
				if (modalElement && window.bootstrap) {
					const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
					modal.show();
				}
			});
		},
		getSectionRowsForProperty(section, property) {
			const cache = this.propertyMovementCache[property?.property_id] || {};
			const item = property?.property_description || '-';
			const pfNo = this.form.pf_number || '-';
			if (section === 'fsl') {
				return (cache.movements || [])
					.filter((movement) => movement.type === 'fsl_send')
					.map((movement) => ({
						partial_flag: movement.fsl_detail?.is_partial ? 'Yes' : 'No',
						pf_no: pfNo,
						item,
						date_sent: this.formatDateOnly(movement.fsl_detail?.date_sent || movement.movement_date),
						acknowledgement_no: movement.fsl_detail?.acknowledgement_no || '',
						date_received: this.formatDateOnly(movement.fsl_detail?.date_received),
						remarks: movement.remarks || ''
					}));
			}
			if (section === 'court') {
				return (cache.movements || [])
					.filter((movement) => movement.type === 'court_send')
					.map((movement) => ({
						partial_flag: movement.court_submission?.is_partial ? 'Yes' : 'No',
						pf_no: pfNo,
						item,
						date_sent: this.formatDateOnly(movement.court_submission?.date_sent || movement.movement_date),
						submitting_officer_name: movement.court_submission?.submitting_officer_name || '',
						receiving_court_staff_name: movement.court_submission?.receiving_court_staff_name || '',
						pr_number: movement.court_submission?.pr_number || '',
						remarks: movement.remarks || ''
					}));
			}
			return (cache.destruction_details || []).map((detail) => ({
				pf_no: pfNo,
				item,
				destruction_date: this.formatDateOnly(detail.destruction_date),
				ordering_authority: detail.ordering_authority || '',
				ordering_authority_designation: detail.ordering_authority_designation || '',
				remarks: detail.remarks || ''
			}));
		},
		getMuddemalFieldHistory(field) {
			let vm = this;
			vm.muddemal_history_status = true;
			vm.property_history_status = false;
			vm.muddemal_meta.field = field
			vm.muddemal_meta.muddemal_id = vm.form.muddemal_id
			vm.$store
				.dispatch("post", { uri: "getMuddemalEditHistory", data: vm.muddemal_meta })
				.then(function (response) {
					vm.muddemal_history = response.data.data
					vm.muddemal_meta.totalRows = response.data.meta.total;
					vm.muddemal_meta.lastPage = response.data.meta.last_page;
					vm.muddemal_meta.from = response.data.meta.from;
					vm.muddemal_meta.maxPage = vm.muddemal_meta.lastPage >= 3 ? 3 : vm.muddemal_meta.lastPage;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		onPageChange(page) {
			this.history_meta.page = page;
			if (this.property_history_status) {
				this.getPropertyFieldHistory(this.property, this.history_meta.field);
			} else {
				this.getMuddemalFieldHistory(this.muddemal_history.field);
			}
		},
		search() {
			let vm = this;
			if (vm.property_history_status) {
				vm.history_meta.page = 1;
				vm.getPropertyFieldHistory(vm.property, vm.history_meta.field);
			} else {
				vm.muddemal_meta.page = 1;
				vm.getMuddemalFieldHistory(vm.muddemal_history.field);
			}
		},
		getPropertyFieldHistory(property, field) {
			let vm = this;
			vm.muddemal_history_status = false;
			vm.property_history_status = true;
			vm.property = property
			vm.history_meta.property_id = property.property_id
			vm.history_meta.field = field
			vm.history_meta.muddemal_id = vm.form.muddemal_id
			if (property.property_id) {
				vm.$store
					.dispatch("post", { uri: "getPropertyEditHistory", data: vm.history_meta })
					.then(function (response) {
						vm.field_history = response.data.data
						vm.history_meta.totalRows = response.data.meta.total;
						vm.history_meta.lastPage = response.data.meta.last_page;
						vm.history_meta.from = response.data.meta.from;
						vm.history_meta.maxPage = vm.history_meta.lastPage >= 3 ? 3 : vm.history_meta.lastPage;
						// vm.case_stages = response.data.data;
						// vm.getPoliceStations();
					})
					.catch(function (error) {
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
			} else {
				vm.field_history = [];
			}

		},

		changeDateFormat(date) {
			if (date) {
				return moment(date).format('YYYY-MM-DD HH:mm')
			}
		},
		getPropertyTypeName(property) {
			if (!property || !this.property_types) return '';
			const pr = this.property_types.find(function (el) { return el.property_type_id == property.property_type_id; });
			const name = pr?.property_type ?? property?.property_type?.property_type ?? '';
			return String(name).toLowerCase();
		},
		isWeightBasedProperty(property) {
			const name = this.getPropertyTypeName(property);
			const keywords = ['drug', 'gold', 'silver', 'diamond', 'precious metal', 'narcotic', 'grams', 'contraband'];
			return keywords.some(kw => name.includes(kw));
		},
		isCountBasedProperty(property) {
			const name = this.getPropertyTypeName(property);
			const keywords = ['vehicle', 'laptop', 'mobile', 'electronic'];
			return keywords.some(kw => name.includes(kw));
		},
		isQuantityOnlyProperty(property) {
			const name = this.getPropertyTypeName(property);
			const keywords = ['vehicle', 'laptop', 'mobile', 'electronic', 'cash', 'others'];
			return keywords.some(kw => name.includes(kw));
		},
		formatQtyForDisplay(property, qty) {
			if (qty == null || qty === '' || isNaN(Number(qty))) return '0';
			const n = Number(qty);
			if (this.isWeightBasedProperty(property)) {
				if (n >= 1000) return `${(n / 1000).toFixed(3)} kg`;
				return `${n.toFixed(3)} gm`;
			}
			return `${Math.floor(n)} nos.`;
		},
		getMovementHistoryBullets(property) {
			if (!property || !property.property_id) return [];
			const cache = this.propertyMovementCache[property.property_id];
			const movements = cache?.movements || [];
			const isWeight = this.isWeightBasedProperty(property);
			return movements.map(m => {
				const qty = m.quantity_moved != null ? Number(m.quantity_moved) : 0;
				const qtyStr = isWeight
					? (qty >= 1000 ? `${(qty / 1000).toFixed(3)} kg` : `${qty.toFixed(3)} gm`)
					: `${Math.floor(qty)} nos.`;
				switch (m.type) {
					case 'fsl_send': return `${qtyStr} sent to FSL`;
					case 'fsl_receive': return `${qtyStr} received from FSL`;
					case 'court_send': return `${qtyStr} sent to Court`;
					case 'destruction': return `${qtyStr} destroyed`;
					case 'location_change': return `${qtyStr} location changed`;
					default: return `${qtyStr} (${m.type || 'movement'})`;
				}
			});
		},
		formatAvailableAtPS(property) {
			if (!property || !property.property_id) return '—';
			const cache = this.propertyMovementCache[property.property_id];
			const fromForm = this.getQuantityFromForm(property);
			const allocated = cache?.allocated != null ? cache.allocated : 0;
			const available = fromForm > 0 ? Math.max(0, fromForm - allocated) : (cache?.availablePSQuantity ?? 0);
			return this.formatQtyForDisplay(property, available);
		},
		checkPropertyType(property) {
			let vm = this
			let pr = this.property_types.filter(function (element) {
				return element.property_type_id == property.property_type_id
			})
			if (pr.length) {
				if (vm.isWeightBasedProperty(property)) {
					property.amount_input_group = 'input-group'
					property.amount_width = 'width:90px'
					property.amount_display = 'display:block'
					property.amount_status = false
				} else if (vm.isQuantityOnlyProperty(property)) {
					property.amount_input_group = ''
					property.amount_display = 'display:none'
					property.amount_width = 'width:135px'
					property.amount_status = true
					property.kilogram = ''
				} else {
					property.amount_input_group = ''
					property.amount_display = 'display:none'
					property.amount_width = 'width:135px'
					property.amount_status = true
					property.kilogram = ''
					property.grams = ''
				}
			}
			let property_type = this.property_types.find(ele => ele.property_type_id == property.property_type_id);
			if (property_type) {
				if (property_type.property_type == 'Others') {
					property.valuable_non_valuable = 'Non-Valuable';
					property.property_value_status = true;
				} else {
					property.valuable_non_valuable = 'Valuable';
					property.property_value_status = false;
				}
			}
		},
		getYearFromDate(date) {
			let vm = this;
			vm.form.year = new Date(date).getFullYear();
		},
		showColumn(key, value, property) {
			if (key == "remarks" && value == 1) {
				property.remarks_if_property_not_available = "";
				property.remarks_input_group = ''
				property.remarks_display = 'display:none'
				property.remarks_status = true
			} else {
				property.remarks_input_group = 'input-group'
				property.remarks_display = 'display:block'
				property.remarks_status = false
			}
		},
		showProperty(key, value, property) {
			let vm = this;
			if (key == "valuable" && value == "Valuable") {
				property.property_value_input_group = 'input-group'
				property.property_value_display = 'display:block'
				property.property_value_width = 'width:90px'
				property.property_value_status = false
			} else {
				property.property_value = "";
				property.property_value_input_group = ''
				property.property_value_display = 'display:none'
				property.property_value_width = 'width:133px'
				property.property_value_status = true
			}
		},
		getFilteredPropertyDisposals(property) {
			const excluded = ['Sent to FSL and Received from FSL', 'Sent to court', 'Destroyed'];
			return (this.property_disposals || []).filter(function (d) {
				const isExcluded = excluded.includes(d.property_disposal_stage);
				if (isExcluded && d.property_disposal_stage_id != property?.property_disposal_stage_id) return false;
				return true;
			});
		},
		getDisposedStatus(key, value, property) {
			let vm = this;
			if (key == "auction") {
				let disposal = vm.property_disposals.filter(function (ele) {
					return ele.property_disposal_stage_id == value;
				});
				if (disposal.length && disposal[0].property_disposal_stage == "Auction") {
					property.auction_status = false;
					property.auction_value_input_group = 'input-group'
					property.auction_value_display = 'display:block'
					property.auction_value_width = 'width:80px'
				} else {
					property.auction_status = true;
					property.auction_value_input_group = ''
					property.auction_value_display = 'display:none'
					property.auction_value_width = 'width:125px'
					property.auction_sold_value = null;
					property.auction_sold_date = null;
				}
			}
		},
		getDisposedStatus1(key, value, property) {
			let vm = this;
			if (key == "property_disposed" && value == true) {
				property.auction_status = true;
				property.disposed_input_group = 'input-group'
				property.disposed_display = 'display:block'
				property.disposed_width = 'width:155px'
				property.disposed_status = false

				// if(property.property_disposal_stage_id == null){
				//     property.auction_value_input_group = 'input-group'
				//     property.auction_value_display = 'display:block'
				//     property.auction_value_width = 'width:80px'
				//     property.auction_status = false;
				// }


			} else {
				property.property_disposal_stage_id = "null";
				property.auction_status = false;

				property.disposed_input_group = ''
				property.disposed_display = 'display:none'
				property.disposed_width = 'width:200px'
				property.disposed_status = true
				property.auction_sold_value = null;
				property.auction_sold_date = null;

				property.auction_value_input_group = ''
				property.auction_value_display = 'display:none'
				property.auction_value_width = 'width:125px'
				property.auction_status = true;
			}
		},

		addProperty() {
			let vm = this
			if (vm.form.properties.length == 0) {
				vm.form.properties.push({
					property_detail_id: "",
					property_type_id: "",
					property_description: "",
					quantity: 0,
					siezed_property_available: 1,
					remarks_if_property_not_available: "",
					valuable_non_valuable: "",
					property_value: "",
					property_photo: "",
					property_photo_name: "",
					image: "",
					property_type: "",
					officer_incharge: "",
					disposed: 0,
					property_disposal_stage_id: null,
					instructions_by_officer: "",
					auction_sold: null,
					disposed_date: null,
					auction_sold_value: null,
					auction_sold_date: null,
					remarks_input_group: '',
					remarks_display: 'display:none',
					property_value_display: 'display:none',
					property_value_width: 'width:133px',
					disposed_display: 'display:none',
					disposed_width: 'width:200px',
					auction_value_display: 'display:none',
					auction_value_width: 'width:125px',
					amount_display: 'display:none',
					amount_width: 'width:135px',
					remarks_status: true,
					errors: [],
				});
			} else {
				let previous_property = vm.form.properties[vm.form.properties.length - 1]
				previous_property.errors = [];
				if (!previous_property.property_type_id || !previous_property.property_description) {
					if (previous_property.property_type_id == "") {
						previous_property.errors.property_type_id = ["property_type_id field cannot be empty"];
					}
					if (previous_property.property_description == "") {
						previous_property.errors.property_description = ["property_description field cannot be empty"];
					}
					if (previous_property.disposed && !previous_property.property_disposal_stage_id) {
						previous_property.errors.property_disposal_stage_id = ["property disposed reason cannot be empty"];
					}
					if (previous_property.property_type_id) {
						if (vm.isWeightBasedProperty(previous_property)) {
							previous_property.errors.kilogram = (!previous_property.kilogram && !previous_property.grams) ? ["kilogram field cannot be empty"] : "";
							previous_property.errors.grams = (!previous_property.kilogram && !previous_property.grams) ? ["grams field cannot be empty"] : "";
						} else if (vm.isQuantityOnlyProperty(previous_property)) {
							previous_property.errors.grams = (previous_property.grams == null || previous_property.grams === '' || Number(previous_property.grams) < 1) ? ["quantity (in numbers) is required and must be at least 1"] : "";
						} else {
							previous_property.errors.kilogram = "";
							previous_property.errors.grams = "";
						}
					}
					if (previous_property.siezed_property_available == "0" && !previous_property.remarks_if_property_not_available) {
						previous_property.errors.remarks_if_property_not_available = ["remarks if property not available cannot be empty"];
					}
					if (previous_property.valuable_non_valuable == "Valuable" && !previous_property.property_value) {
						previous_property.errors.property_value = ["property value cannot be empty"];
					}
					if (previous_property.disposed == "true" && previous_property.property_disposal_stage_id == null) {
						previous_property.errors.property_disposal_stage_id = ["property disposal stage id cannot be empty"];
					}
					if (previous_property.disposed == "true" && !previous_property.disposed_date) {
						previous_property.errors.disposed_date = ["disposed date cannot be empty"];
					}
					if (previous_property.property_disposal_stage_id) {
						let disposal = vm.property_disposals.filter(function (ele) {
							return ele.property_disposal_stage_id == previous_property.property_disposal_stage_id;
						});
						if (disposal.length && disposal[0].property_disposal_stage == "Auction") {
							if (previous_property.auction_sold == null) {
								previous_property.errors.auction_sold = ["auction value cannot be empty"];
							}
							if (previous_property.auction_sold_value == null) {
								previous_property.errors.auction_sold_value = ["auction value cannot be empty"];
							}
							if (!previous_property.auction_sold_date) {
								previous_property.errors.auction_sold_date = ["auction date cannot be empty"];
							}
						}
					}
				}

				if (previous_property.siezed_property_available) {
					if (previous_property.siezed_property_available == "0" && !previous_property.remarks_if_property_not_available) {
						previous_property.errors.remarks_if_property_not_available = ["remarks if property not available cannot be empty"];
					}
				}
				if (previous_property.valuable_non_valuable) {
					if (previous_property.valuable_non_valuable == "Valuable" && !previous_property.property_value) {
						previous_property.errors.property_value = ["property value cannot be empty"];
					}
				}
				if (previous_property.disposed) {
					if (previous_property.disposed == "true" && previous_property.property_disposal_stage_id == null) {
						previous_property.errors.property_disposal_stage_id = ["property disposal stage id cannot be empty"];
					}
					if (previous_property.disposed == "true" && !previous_property.disposed_date) {
						previous_property.errors.disposed_date = ["disposed date cannot be empty"];
					}
				}
				if (previous_property.property_disposal_stage_id) {
					let disposal = vm.property_disposals.filter(function (ele) {
						return ele.property_disposal_stage_id == previous_property.property_disposal_stage_id;
					});
					if (disposal.length && disposal[0].property_disposal_stage == "Auction") {
						if (previous_property.auction_sold_value == null) {
							previous_property.errors.auction_sold_value = ["auction sold value cannot be empty"];
						}
						if (!previous_property.auction_sold_date) {
							previous_property.errors.auction_sold_date = ["auction sold date cannot be empty"];
						}
						if (!previous_property.officer_incharge) {
							previous_property.errors.officer_incharge = ["officer incharge field cannot be empty"];
						}
					}
				}
				if (!Object.keys(previous_property.errors).length) {
					vm.form.properties.push({
						property_detail_id: "",
						property_type_id: "",
						property_description: "",
						siezed_property_available: 1,
						remarks_if_property_not_available: "",
						valuable_non_valuable: "",
						property_value: "",
						property_photo: "",
						property_photo_name: "",
						image: "",
						property_type: "",
						property_disposal_stage_id: null,
						disposed: 0,
						disposed_date: null,
						officer_incharge: "",
						instructions_by_officer: "",
						auction_sold: null,
						auction_sold_value: null,
						auction_sold_date: null,
						remarks_input_group: '',
						remarks_display: 'display:none',
						remarks_status: true,
						property_value_input_group: '',
						property_value_display: 'display:none',
						property_value_width: 'width:133px',
						property_value_status: true,
						disposed_input_group: '',
						disposed_display: 'display:none',
						disposed_width: 'width:200px',
						disposed_status: true,
						auction_value_input_group: '',
						auction_value_display: 'display:none',
						auction_value_width: 'width:125px',
						auction_status: true,
						amount_input_group: '',
						amount_display: 'display:none',
						amount_width: 'width:135px',
						amount_status: true,
						quantity: 0,
						errors: [],
					});
				}
			}
		},
		getSubDivisionAndCircle(police_station_id) {
			let vm = this;
			let police_Station = vm.police_stations.filter(function (ele) {
				return ele.police_station_id == police_station_id;
			});
			if (police_Station.length) {
				vm.form.sub_division_id = police_Station[0]?.sub_division?.sub_division_id ?? '';
				vm.form.circle_id = police_Station[0]?.circle?.circle_id ?? '';
				if (police_Station[0]?.sub_division?.sub_division == 'CCB') {
					vm.getAllPoliceStations();
					vm.selected_division = 'CCB';
				} else {
					vm.form.transferred_ps_id = "";
					vm.selected_division = '';
				}
			}
		},
		getAllPoliceStations() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getPoliceStations" })
				.then(function (response) {
					vm.all_police_stations = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getProperty(property) {
			this.property.property_type = property.property_type;
		},
		getCaseStages() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getCaseStages" })
				.then(function (response) {
					vm.case_stages = response.data.data;
					vm.getPoliceStations();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getPoliceStations() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getUserPoliceStations" })
				.then(function (response) {
					vm.police_stations = response.data.data;
					if (vm.police_stations?.length) {
						if (vm.status) {
							vm.form.police_station_id = vm.police_stations[0].police_station_id;
						} else if (!vm.form.police_station_id || vm.form.police_station_id === '') {
							vm.form.police_station_id = vm.police_stations[0].police_station_id;
						}
					}
					vm.getSubDivisionAndCircle(vm.form.police_station_id);
					vm.getSubDivisions();
					vm.getCircles();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getSubDivisions() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getSubDivisions" })
				.then(function (response) {
					vm.sub_divisions = response.data.data;
					vm.getPropertyTypes();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getCircles() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getCircles" })
				.then(function (response) {
					vm.circles = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getPropertyTypes() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getPropertyTypes" })
				.then(function (response) {
					vm.property_types = response.data.data;
					vm.getPropertyDisposals();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getPropertyDisposals() {
			let vm = this;
			let uri = { uri: "getPropertyDisposalStages" };
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					vm.property_disposals = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		discardForm() {
			let vm = this;
			vm.property.property_type_id = "";
			vm.property.property_description = "";
			vm.property.quantity = 0;
			vm.property.siezed_property_available = null;
			vm.property.remarks_if_property_not_available = "";
			vm.property.valuable_non_valuable = "";
			vm.property.property_value = "";
			vm.property.property_photo = "";
			vm.formStatus = true;
			vm.$refs.pf_number.focus();
			vm.errors = [];
		},
		deleteRow(property, key) {
			let vm = this;
			if (confirm("Do You want to Delete this Record?..")) {
				vm.form.deleted_properties.push(property.property_id), vm.form.properties.splice(key, 1);
				// vm.discardForm()
			}
		},
		getPropertyPhoto(e, property) {
			let vm = this;
			property.image = e.target.files[0];
			property.property_photo_name = property.image?.name;
			let reader = new FileReader();
			reader.readAsDataURL(property.image);
			reader.onload = (e) => {
				property.property_photo = e.target.result;
			};
			property.url = URL.createObjectURL(property.image);
		},

		updateForms() {
			let vm = this;
			let errs = [];
			let property = {
				errors: [],
			};
			let prop_error_counts = 0;
			if (vm.form.properties.length) {
				errs = [];
				vm.form.properties.filter(function (prop) {
					if (prop.disposed_date === "") {
						prop.disposed_date = null
					}
					if (prop.siezed_property_available === "" || prop.siezed_property_available === "null") {
						prop.siezed_property_available = null
					}
					prop.errors = [];
					if (
						!prop.property_type_id &&
						!prop.property_description &&
						!prop.siezed_property_available &&
						!prop.remarks_if_property_not_available &&
						!prop.valuable_non_valuable &&
						!prop.property_value &&
						!prop.disposed &&
						!prop.property_disposal_stage_id
					) {
						vm.form.properties.pop(prop);
					}
					if (prop.property_type_id == "" && vm.form.properties.length != 0) {
						prop.errors.property_type_id = ["property_type_id field cannot be empty"];
					}
					if (prop.property_type_id) {
						if (vm.isWeightBasedProperty(prop)) {
							if (!prop.kilogram && !prop.grams) {
								prop.errors.kilogram = ["kilogram field cannot be empty"];
								prop.errors.grams = ["grams field cannot be empty"];
								errs.kilogram = ["kilogram field cannot be empty"];
								errs.grams = ["grams field cannot be empty"];
							}
						} else if (vm.isQuantityOnlyProperty(prop)) {
							if (prop.grams == null || prop.grams === '' || Number(prop.grams) < 1) {
								prop.errors.grams = ["quantity (in numbers) is required and must be at least 1"];
								errs.grams = ["quantity (in numbers) is required and must be at least 1"];
							}
						}
						if (prop.valuable_non_valuable == '') {
							prop.errors.valuable_non_valuable = ["This field cannot be empty."];
						}
					}
					if (vm.form.properties.length && prop.property_description == "") {
						prop.errors.property_description = ["property_description field cannot be empty"];
						errs.property_description = ["property_description field cannot be empty"];
					}
					if (prop.siezed_property_available == "0" && !prop.remarks_if_property_not_available) {
						prop.errors.remarks_if_property_not_available = ["remarks if property not available cannot be empty"];
						errs.remarks_if_property_not_available = ["remarks if property not available cannot be empty"];
					}
					if (prop.valuable_non_valuable == "Valuable" && !prop.property_value) {
						if (prop.property_value == 0) {

						} else {
							prop.errors.property_value = ["property value cannot be empty"];
							errs.property_value = ["property value cannot be empty"];
						}
					}
					if (prop.disposed == 1 && prop.property_disposal_stage_id == null) {
						prop.errors.property_disposal_stage_id = ["property disposal stage id cannot be empty"];
						errs.property_disposal_stage_id = ["property disposal stage id cannot be empty"];
					}
					if (prop.disposed == 1 && !prop.disposed_date) {
						prop.errors.disposed_date = ["disposed date cannot be empty"];
						errs.disposed_date = ["disposed date cannot be empty"];
					}
					if (prop.disposed == 1 && !prop.officer_incharge) {
						prop.errors.officer_incharge = ["Officer incharge field cannot be empty"];
						errs.officer_incharge = ["Officer incharge field cannot be empty"];
					}
					if (prop.property_disposal_stage_id) {
						let disposal = vm.property_disposals.filter(function (ele) {
							return ele.property_disposal_stage_id == prop.property_disposal_stage_id;
						});
						if (disposal.length && disposal[0].property_disposal_stage == "Auction") {
							if (prop.auction_sold_value == null) {
								prop.errors.auction_sold_value = ["auction sold value cannot be empty"];
								errs.auction_sold_value = ["auction sold value cannot be empty"];
							}
							if (!prop.auction_sold_date) {
								prop.errors.auction_sold_date = ["auction sold date cannot be empty"];
								errs.auction_sold_date = ["auction sold date cannot be empty"];
							}
						}
					}
					prop_error_counts = Object.keys(prop.errors)?.length;
				});
			}
			if (!Object.keys(errs).length) {
				if (prop_error_counts != 0) {
					return;
				}

				let properties = [];
				properties.push(vm.form.properties);
				let data = new FormData();
				data.append("muddemal_id", this.form.muddemal_id);
				data.append("pf_number", this.form.pf_number);
				data.append("pf_date", this.form.pf_date);
				data.append("year", this.form.year);
				data.append("crime_no_sec", this.form.crime_no_sec);
				data.append("number_type", this.form.number_type);
				data.append("section_of_law", this.form.section_of_law);
				data.append("investigation_officer", this.form.investigation_officer);
				data.append("seizing_officer", this.form.seizing_officer);
				data.append("crime_year", this.form.crime_year);
				data.append("siezed_from_whom", this.form.siezed_from_whom);
				data.append("siezed_from_place", this.form.siezed_from_place);
				data.append("cc_sc_no", this.form.cc_sc_no);
				data.append("case_stage_id", this.form.case_stage_id);
				data.append("pr_no", this.form.pr_no);
				data.append("pr_date", this.form.pr_date);
				data.append("holding_officer", this.form.holding_officer);
				data.append("police_station_id", this.form.police_station_id);
				data.append("sub_division_id", this.form.sub_division_id);
				data.append("circle_id", this.form.circle_id);
				data.append("transferred_ps_id", this.form.transferred_ps_id);
				data.append("muddemal_status", this.form.muddemal_status);
				data.append("properties", JSON.stringify(vm.form.properties));
				data.append("deleted_properties", JSON.stringify(vm.form.deleted_properties));

				let loader = vm.$loading.show();
				axios
					.post(vm.$store.state.apiUrl + "api/updateMuddemal", data, {
						headers: {
							"Content-Type": "multipart/form-data",
							Authorization: "Bearer" + " " + vm.$store.getters.token,
						},
					})
					.then((response) => {
						loader.hide();
						vm.$store.dispatch("success", "Muddemal Updated successfully");
						vm.$router.push("/muddemal");
					})
					.catch(function (error) {
						loader.hide();
						vm.errors = error.response.data.errors;
						if (vm.errors) {
							if (vm.form.properties.length == 0) {
								vm.addProperty();
							}
						}
						vm.$store.dispatch("error", error.response.data.message);
					});
			}
		},

		getMeasuringUnit(property) {
			return this.property_types.find(ele => ele.property_type_id === property.property_type_id)?.measuring_unit;
		},

		isNumber(e) {
			const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
			const keyPressed = e.key;
			if (!keysAllowed.includes(keyPressed)) {
				e.preventDefault()
			}
		},

		deletePropertyImage(property) {
			if (property.image) {
				property.property_photo_name = null;
				property.property_photo = null;
				return;
			}
			if (!confirm('Property image will be deleted permanently.')) return;

			let vm = this;
			let loader = this.$loading.show();
			vm.$store.dispatch('post', { uri: 'deletePropertyImage', data: { property_id: property.property_id } })
				.then(response => {
					loader.hide();
					const index = vm.form.properties.findIndex(ele => ele.property_id === property.property_id);
					let temp = response.data.property;
					temp.remarks_display = 'display:none';
					temp.property_value_display = 'display:none';
					temp.property_value_width = 'width:133px';
					temp.disposed_display = 'display:none';
					temp.disposed_width = 'width:200px';
					temp.auction_value_display = 'display:none';
					temp.auction_value_width = 'width:125px';
					temp.amount_display = 'display:none';
					temp.amount_width = 'width:135px';
					if (index !== -1) {
						vm.form.properties[index] = temp;
					}

					vm.$store.dispatch('success', response.data.message);
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch('error', error.response.data.message);
				})
		}
	},
};
</script>

<style scoped>
.modal-img {
	width: -webkit-fill-available;
}

.modal-close {
	background-color: white;
	border-radius: 50%;
	padding: 5px;
}

input:focus,
select:focus {
	outline: none;
	box-shadow: 0 0 0 0 transparent;
}

.menu_icon {
	font-size: 20px;
	opacity: 0.85;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.right-inner-addon {
	position: relative;
}

.right-inner-addon input {
	padding-right: 35px !important;
}

.right-inner-addon i {
	position: absolute;
	right: 0px;
	padding: 9px 9px;
}

.input-group {
	position: relative !important;
	display: flex !important;
	flex-wrap: nowrap !important;
	align-items: stretch !important;
	width: 100% !important;
}

.input-group-append {
	background-color: transparent !important;

}

.input-group-text {
	background-color: transparent !important;
	border-top-left-radius: 0px !important;
	border-bottom-left-radius: 0px !important;
}

.input-group select,
.input-group input,
.border-right-0 {
	border-right: 0px !important
}

.lh-1-2 {
	line-height: 1.2 !important;
}

.border-left-0 {
	border-left: 0px;
}

.input-group-text.is-invalid {
	border-color: #dc3545;
	padding-right: calc(1.5em + 0.812rem);
	background-repeat: no-repeat;
	background-position: right calc(0.375em + 0.203rem) center;
	background-size: calc(0.75em + 0.406rem) calc(0.75em + 0.406rem);
}

.input-group input,
select:focus {
	outline: none;
	box-shadow: none !important;
}

.details-table th,
.details-table td {
	vertical-align: middle;
}

.details-table .w-pf-no {
	min-width: 110px;
}

.details-table .w-item {
	min-width: 220px;
}

.details-table .w-date {
	min-width: 190px;
}

.details-table .w-ack {
	min-width: 180px;
}

.details-table .w-name {
	min-width: 170px;
}

.col-fsl-actions,
.col-court-actions,
.col-destroyed-actions {
	min-width: 78px;
}

.col-fsl-actions {
	min-width: 90px;
}

.col-current-location {
	min-width: 130px;
}

.col-shelf {
	min-width: 80px;
}
</style>
